import React from "react";
import WhiteBox from "../../../shared/components/WhiteBox/WhiteBox";
import BlockheaderV2 from "../../../shared/components/BlockheaderV2/BlockheaderV2";
import {
  StyledFeaturedMatch,
  StyledFeaturedMatchHeader,
  StyledSponsorWrapper,
} from "./StyledFeaturedMatch";
import {
  formatScores,
  statusTypes,
  useMatchData,
} from "../../../mls-match-list/utils";
import VenueBroadcasterBar from "../../../shared/components/VenueBroadcasterBar/VenueBroadcasterBar";
import { useReactAppState } from "../../../shared/containers/utils";
import { getDateTranslation } from "../../../mls-vertical-scoreboard/utils";

import MatchButtonStreamer from "../MatchButtonStreamer/MatchButtonStreamer";
import { formatMatchMinutes } from "../../../mls-match-summary/utils";
import MatchTile from "../../../shared/components/MatchTile/MatchTile";
import StatusStamp from "../../../shared/components/StatusStamp/StatusStamp";
import { StyledMatchButtonStreamerWrapper } from "../MatchButtonStreamer/StyledMatchButtonStreamer";
import { StyledVerticalMatchExplainerBar } from "../../../mls-vertical-scoreboard/components/VerticalMatch/StyledVerticalMatch";
import ExplainerBar from "../../../shared/components/ExplainerBar/ExplainerBar";
import { StyledMatchTileWrapper } from "../MatchTileWrapper/StyledMatchTileWrapper";
import PreviousFeaturedMatch from "../PreviousFeaturedMatch/PreviousFeaturedMatch";
import { backgroundTypes } from "../../../shared/styled/Theme";
import { Link } from "../../../shared/components/Link/Link";
import SponsorV2 from "../../../shared/components/SponsorV2/SponsorV2";
import FeaturedMatchPromo from "../FeaturedMatchPromo/FeaturedMatchPromo";
import useIsMobile from "../../../shared/hooks/useIsMobile";
import MatchRoundInfo from "../MatchRoundInfo/MatchRoundInfo";
import MatchDataLayer from "../../../mls-match-list/components/MatchDataLayer";

function FeaturedMatch(props) {
  const {
    queryClassName,
    previousMatches,
    nextMatches,
    isExtraSmallContainer,
    forgeMatches,
    featuredMatch,
    featuredForgeMatch,
    compactVersion,
  } = props;

  const showLiveDot = isExtraSmallContainer && compactVersion;
  return (
    <>
      {previousMatches.length ? (
        <WhiteBox className="mls-c-featured-match__previous">
          {previousMatches.map((match) => (
            <PreviousFeaturedMatch
              forgeMatch={forgeMatches?.get(match.match_id)}
              mlsMatch={match}
              key={match.match_id}
              showLiveDot={showLiveDot}
              isExtraSmallContainer={isExtraSmallContainer}
            />
          ))}
        </WhiteBox>
      ) : null}
      <MatchDataLayer
        queryClassName={queryClassName}
        useEmptyClasses
        useMatchData
        mlsMatch={featuredMatch}
        matchSportecId={featuredMatch?.match_id}
        statsAPIMatch={featuredMatch}
        forgeMatch={forgeMatches?.get(featuredMatch.match_id)}
      >
        <FeaturedMatchComponent {...props} />
      </MatchDataLayer>
      {nextMatches.length ? (
        <WhiteBox className="mls-c-featured-match__previous">
          {nextMatches.map((match) => (
            <PreviousFeaturedMatch
              forgeMatch={forgeMatches?.get(match.match_id)}
              mlsMatch={match}
              key={match.match_id}
              showLiveDot={showLiveDot}
              isExtraSmallContainer={isExtraSmallContainer}
            />
          ))}
        </WhiteBox>
      ) : null}
    </>
  );
}


function FeaturedMatchComponent({
  queryClassName,
  compactVersion,
  isSmallContainer,
  isExtraSmallContainer,
  showClubRanks,
  showCompetitionStage,
  showRoundDetail,
  showGroupInformation,
  hideBlockheader,
  blockheaderTitle,
  blockheaderSubtitle,
}) {

  const matchData = useMatchData();

  const { homeClubData,
    awayClubData,
    season,
    slug,
    status,
    winnerStatus,
    period,
    resultType,
    matchDateTime,
    venue,
    mediaProviders,
    minuteDisplay,
    competition,
    appleSubscriptionTier,
    promoInfo,
    leagueMatchTitle,
    roundName,
    roundGroup,
    competitionPhase,
    homeClubRank,
    awayClubRank, } = matchData

  const { t, urlList, directoryList } = useReactAppState();

  const { isHomeWinner, isAwayWinner } = winnerStatus || {};

  const { homeScore, awayScore, shootoutResult } = formatScores({
    homeClubData,
    awayClubData,
    period,
    resultType,
  });

  const [minutes, extraMinutes] = formatMatchMinutes(minuteDisplay);

  const { localTime } = matchDateTime || {};

  const subtitle = getDateTranslation(localTime, t);

  const { baseUrl } = urlList || {};
  const { matchHubDir } = directoryList || {};
  const { slug: competitionSlug } = competition || {};
  const { season: seasonId } = season || {};
  const matchPageUrl = `${baseUrl}/${matchHubDir}/${competitionSlug}/${seasonId}/matches/${slug}`;

  const { shortName: homeShortName } = homeClubData || {};
  const { shortName: awayShortName } = awayClubData || {};

  const title = `${homeShortName} vs ${awayShortName}`;

  const { sponsorImage, promotionalSponsor } = promoInfo;
  const { assetUrl } = sponsorImage || {};

  const hasShortName = compactVersion ? isSmallContainer : true;
  const hasAbbreviation = compactVersion ? !isSmallContainer : false;
  const showLiveDot = isExtraSmallContainer && compactVersion;
  const isMobile = useIsMobile();

  return (
    <StyledFeaturedMatch
      className={`mls-c-featured-match ${queryClassName} ${isMobile ? "--mobile" : ""
        }`}
    >
      <WhiteBox>
        <Link url={matchPageUrl} title={title}>
          <StyledFeaturedMatchHeader
            className={`mls-c-featured-match__header ${queryClassName}`}
          >
            {!hideBlockheader && (
              <BlockheaderV2
                title={
                  blockheaderTitle || leagueMatchTitle || competition?.name
                }
                subtitle={blockheaderSubtitle || subtitle}
              />
            )}
            <StyledSponsorWrapper className="mls-c-featured-match__sponsor">
              {assetUrl && !compactVersion && (
                <SponsorV2
                  hasPresBy={false}
                  templateUrl={assetUrl}
                  url={promotionalSponsor?.url}
                  accessibleText={promotionalSponsor?.accessibleText}
                  openInNewTab={promotionalSponsor?.openInNewTab}
                />
              )}
            </StyledSponsorWrapper>
          </StyledFeaturedMatchHeader>
          <MatchRoundInfo
            competitionPhase={showCompetitionStage ? competitionPhase : null}
            roundName={showRoundDetail ? roundName : null}
            roundGroup={showGroupInformation ? roundGroup : null}
          />
          <StyledMatchTileWrapper
            className={`mls-c-match-tile-wrapper ${queryClassName}`}
          >
            {status?.abbreviation !== statusTypes.pre && (
              <StatusStamp
                abbreviation={status?.abbreviation}
                minuteDisplay={minutes}
                extraMinutes={extraMinutes}
                showLiveDot={showLiveDot}
              />
            )}
            <MatchTile
              status={status}
              homeClubData={homeClubData}
              awayClubData={awayClubData}
              isHomeWinner={isHomeWinner}
              isAwayWinner={isAwayWinner}
              homeScore={homeScore}
              awayScore={awayScore}
              hasShortName={hasShortName}
              hasAbbreviation={hasAbbreviation}
              homeClubRank={showClubRanks ? homeClubRank : null}
              awayClubRank={showClubRanks ? awayClubRank : null}
            />
          </StyledMatchTileWrapper>
          {status?.abbreviation === statusTypes.pre && (
            <VenueBroadcasterBar
              venue={venue}
              mediaProviders={mediaProviders}
              appleSubscriptionTier={appleSubscriptionTier}
              breakStadiumAndBroadcaster
            />
          )}
          {shootoutResult && (
            <StyledVerticalMatchExplainerBar>
              <ExplainerBar text={shootoutResult} />
            </StyledVerticalMatchExplainerBar>
          )}
        </Link>
        <StyledMatchButtonStreamerWrapper
          className={`mls-c-matchbutton --${status?.abbreviation}`}
        >
          <MatchButtonStreamer backgroundColor={backgroundTypes.black} />
        </StyledMatchButtonStreamerWrapper>
        <FeaturedMatchPromo compactVersion={compactVersion} />
      </WhiteBox>
    </StyledFeaturedMatch>
  )

}

// eslint-disable-next-line no-func-assign
FeaturedMatch = React.memo(FeaturedMatch);

export default FeaturedMatch;
